import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LandingPage } from './pages/LandingPage';
import { SelectRegionPage } from './pages/SelectRegionPage';
import { MainPage } from './pages/MainPage';
import { TipsFindPasswordPage } from './pages/TipsFindPasswordPage';
import { WaitingPage } from './pages/WaitingPage';
import { DebugSurveyFlowPage } from './pages/DebugSurveyFlowPage';
import { DebugDashboardPage } from './pages/DebugDashboardPage';
import { CleaningStudyPage } from './pages/CleaningStudyPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'connect',
        element: <SelectRegionPage />,
      },
      {
        // Handles all post-signin states in one mounted instance:
        // INITIAL (sign-in) → CONNECTING (loading) → SUCCESS → CONNECTED / ERROR
        // MainPage rewrites the URL bar as the state advances, so every URL
        // it rewrites to must also be registered here or refresh will 404.
        path: 'connect/signin',
        element: <MainPage />,
      },
      {
        path: 'connect/loading',
        element: <MainPage />,
      },
      {
        // Fixed Google OAuth redirect target (see googleRedirectUri() in
        // GmailConnectPage.tsx) so the registered Google Cloud redirect_uri
        // never depends on which step the user started from.
        path: 'connect/gmail-callback',
        element: <MainPage />,
      },
      {
        path: 'connect/waiting',
        element: <WaitingPage />,
      },
      {
        path: 'connect/success',
        element: <MainPage />,
      },
      {
        path: 'connect/survey',
        element: <MainPage />,
      },
      {
        path: 'dashboard',
        element: <MainPage />,
      },
      {
        path: 'debug/tap-connect/success',
        element: <DebugSurveyFlowPage />,
      },
      {
        path: 'debug/confirmation-code',
        element: <DebugDashboardPage view="confirmation-code" />,
      },
      {
        path: 'debug/view-data',
        element: <DebugDashboardPage view="view-data" />,
      },
      {
        path: 'help/find-password',
        element: <TipsFindPasswordPage />,
      },
      // Clorox standalone "data + survey" experience. All sub-paths render the
      // same mounted CleaningStudyPage, which rewrites the URL as state advances;
      // every rewritten path is registered so a refresh/deep-link doesn't 404.
      {
        path: 'cleaning-study',
        element: <CleaningStudyPage />,
      },
      {
        path: 'cleaning-study/connect',
        element: <CleaningStudyPage />,
      },
      {
        path: 'cleaning-study/connect/signin',
        element: <CleaningStudyPage />,
      },
      {
        path: 'cleaning-study/connect/loading',
        element: <CleaningStudyPage />,
      },
      {
        path: 'cleaning-study/connect/success',
        element: <CleaningStudyPage />,
      },
      {
        path: 'cleaning-study/survey',
        element: <CleaningStudyPage />,
      },
      {
        path: 'cleaning-study/done',
        element: <CleaningStudyPage />,
      },
    ],
  },
]);
